import { isNotUndefined } from "@faire/typescript";

const POPULAR_DISPLAY_PIXEL_RATIOS = [1, 2];

export function buildImageSrcSet(getUrl: (dpr: number) => string | undefined): {
  src: string | undefined;
  srcSet: string | undefined;
} {
  const sources = POPULAR_DISPLAY_PIXEL_RATIOS.map((dpr) => {
    const url = getUrl(dpr);
    return url ? { url, dpr } : undefined;
  }).filter(isNotUndefined);

  const firstSource = sources[0];
  if (firstSource) {
    return {
      src: firstSource.url,
      srcSet: sources
        .map((source) => `${source.url} ${source.dpr}x`)
        .join(", "),
    };
  } else {
    return {
      src: undefined,
      srcSet: undefined,
    };
  }
}
